import React from 'react'
import style from './style.module.sass'
import FilterPanel from './FilterPanel'
import { useRouteMatch, NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Spinner from '../../Spinner'
import { dashboardSetLanguage, userSetArchiveLanguage } from '../../../actions'
import { MenuItem, Select, Button, OutlinedInput } from '@material-ui/core'
import { useActions } from '../../../utils/action-helper'
import { useTheme } from '@material-ui/styles'
import { ArrowBackIos, ArrowDropDown } from '@material-ui/icons'
import { useAutoCompleteStyles } from '../../../utils'
import config from '../../../config'

export default function DashFilters () {
  const { params: { type } } = useRouteMatch()
  const { t } = useTranslation()
  const { theme: { bgColors, colors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = useAutoCompleteStyles(bgColors, colors)()
  // redux
  const loading = useSelector(state => state.dashboardData.loading)
  const archiveLanguage = useSelector(state => state.userData.archiveLanguage)
  const backendLanguages = useSelector(state => state.userData.user?.backend_languages || {})

  const { actionUserSetArchiveLanguage, aDashboardSetLanguage } = useActions({
    actionUserSetArchiveLanguage: userSetArchiveLanguage,
    aDashboardSetLanguage: dashboardSetLanguage
  })

  function handleOnChangeLanguage (e) {
    actionUserSetArchiveLanguage(e.target.value)
    aDashboardSetLanguage(e.target.value)
  }

  const LanguageSelector = () => {
    return (
      <div style={{ float: 'right', marginTop: '-20px' }}>
        <Select
          onChange={handleOnChangeLanguage}
          labelId="language-select-label"
          id="language-select"
          defaultValue={archiveLanguage}
          variant="outlined"
          className={`p-0`}
          input={
            <OutlinedInput
              classes={{ root: isContrast ? classes.outlinedRoot : '' }}
            />
          }
          IconComponent={(props) => (
            <ArrowDropDown {...props} style={{ color: colors.colorText }} />
          )}
          style={{ borderRadius: 18, width: '220px', backgroundColor: bgColors.bgPrimary200, color: colors.colorText }}
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: bgColors.bgPrimary200,
                color: colors.colorText,
                borderRadius: '10px',
              },
            },
          }}
        >
          {
            Object.keys(backendLanguages).map(lang =>
              <MenuItem key={lang} value={lang}>{backendLanguages[lang]['nativeName']}</MenuItem>
            )
          }
        </Select>
      </div>
    )
  }

  return (
    <div className={`${style.mainCont}`}>
      <NavLink className={'p-0 '} to="/dashboard/compare">
        <Button style={{ backgroundColor: bgColors.bgAnalyseBtnActive, color: colors.colorWhite  }} variant="contained">
          <ArrowBackIos className={`mr-2`} style={{ fontSize: 20 }}/>
          {t('to dashboard')}
        </Button>
      </NavLink>
      <LanguageSelector/>
      <div className={`${style.tableWrapper} pb-5 mt-1`}>
        <div className={`d-flex ${style.mediaHandler}`} style={{ gridGap: 10 }}>
          <FilterPanel panel={0}/>
          {type === 'double' && <FilterPanel panel={1}/>}
        </div>
      </div>
      {loading && <Spinner/>}
    </div>
  )
}